import { render, staticRenderFns } from "./price_extend_edit.vue?vue&type=template&id=d6f9d500&"
import script from "./price_extend_edit.vue?vue&type=script&lang=ts&"
export * from "./price_extend_edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports